var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:['header', _vm.isUserFromAPP && 'app-layout_header'],attrs:{"id":"Header"}},[_c('div',{staticClass:"main-container"},[_c('div',{class:[
  'navigation-buttons',
  _vm.isUserFromAPP && 'app-layout_navigation-buttons',
]},_vm._l((_vm.navigationList),function(item,index){return _c('NavigationButton',{key:_vm.refreshButtons + index,ref:'ref' + item.title,refInFor:true,style:({ margin: 'auto 0.1rem' }),attrs:{"icon":item,"notReadNumber":item.notReadNumber},on:{"click":() => _vm.handleTransferScreen(item)}})}),1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }